import styled from 'styled-components';
import { Alert, Button } from 'antd';

export const TableWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #e8e8e8;

  .BaseTable__header {
    background: #fafafa;
    border-bottom: 1px solid #e8e8e8;
  }

  .BaseTable__header-cell {
    padding: 0;
    font-size: 11px;
    color: #8c8c8c;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    font-weight: 600;
  }

  .BaseTable__row {
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #fafafa;
    }
  }

  .BaseTable {
    width: 100%;
    overflow: hidden !important;
  }

  .BaseTable__table {
    width: 100%;
    table-layout: fixed;
  }

  .BaseTable__header,
  .BaseTable__body {
    width: 100%;
    overflow: hidden !important;
  }
`;

export const Row = styled.a`
  display: flex;
  width: 100%;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  height: 100%;

  &:hover {
    color: inherit;
  }

  &:visited {
    color: inherit;
  }
`;

export const FullCell = styled.div<{ $width?: number }>`
  padding: 0 16px 0 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 500;
  font-size: 14px;
  color: #434343;
  line-height: 1.4;
  text-align: left;
  flex: ${({ $width }) => ($width ? `0 0 ${$width}px` : '1 1 0')};
  display: flex;
  align-items: center;
`;

export const Cell = styled.div<{ $width?: number }>`
  padding: 0 16px;
  overflow: visible;
  text-align: left;
  flex: ${({ $width }) => ($width ? `0 0 ${$width}px` : '1 1 0')};
  font-size: 16px;
  color: #434343;
  font-weight: 400;
  line-height: 1.4;
  display: flex;
  align-items: center;
`;

export const HeaderCell = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const HeaderTitle = styled.span`
  font-weight: 600;
  font-size: 11px;
  color: #8c8c8c;
  text-transform: uppercase;
  letter-spacing: 0.7px;
`;

export const DragHandle = styled.div`
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  color: #000;
  cursor: grab;
  z-index: 10;
  padding: 6px;
  font-size: 18px;
  display: flex;
  align-items: center;

  &:hover {
    color: #8c8c8c;
  }

  &:active {
    cursor: grabbing;
  }
`;

export const DraggableRow = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  background: #fff;
`;

export const RowWrapper = styled.div`
  flex: 1;
  padding-left: 32px;
  height: 100%;
  display: flex;
  align-items: stretch;
`;

export const DeletedFlowCell = styled(FullCell)`
  align-items: center;
  padding: 0 16px;
  border-left: 3px solid #ff4d4f;
`;

export const DeletedFlowAlert = styled(Alert)`
  display: inline-flex;
  width: auto;
  border-radius: 4px;
  font-size: 13px;
`;

export const DeleteButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const DeleteButton = styled(Button)`
  &.ant-btn-dangerous {
    font-size: 15px;
    border-radius: 4px;

    .anticon {
      font-size: 15px;
    }
  }
`;

export const GaugeWrapper = styled.div<{ $dodEnabled?: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  width: ${({ $dodEnabled }) => ($dodEnabled ? '265px' : '200px')};
`;

export const PercentBadge = styled.span<{ $positive: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ $positive }) => ($positive ? '#16a34a' : '#dc2626')};
  background: ${({ $positive }) => ($positive ? '#e6f5ff' : '#ffe6e6')};
  padding: 2px 4px;
  border-radius: 4px;
  white-space: nowrap;
  flex-shrink: 0;

  .anticon {
    font-size: 11px;
  }
`;

export const SuccessCellWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
  align-items: center;
`;

export const SuccessTrendWrapper = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  height: 40px;
`;

export const GaugeContainer = styled.div<{ $dodEnabled?: boolean }>`
  padding: 0 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  width: 200px;
`;
export const TimeoutCaption = styled.span`
  font-size: 12px;
  color: #8c8c8c;
  padding-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CompletePctLabel = styled.div<{ $width: number }>`
  display: flex;
  flex-direction: column;
  width: ${({ $width }) => $width}px;
  flex-shrink: 0;
  justify-content: center;
  gap: 2px;
`;

export const CompletePctValue = styled.span`
  white-space: nowrap;
  font-size: 16px;
  font-weight: 400;
  color: #434343;
`;

export const DodNeutral = styled.span`
  font-size: 11px;
  color: #8c8c8c;
`;
